import { Box } from '@mui/material';
import { GridSingleSelectColDef } from '@mui/x-data-grid-premium';
import AutocompleteField, {
  AutocompleteFieldProps,
} from 'components/forms/fields/autocomplete-field/autocomplete-field.component';
import { IncSwitchBaseProps } from 'components/forms/fields/inc-switch-field/inc-switch-base/inc-switch-base.component';
import IncSwitchField from 'components/forms/fields/inc-switch-field/inc-switch-field.component';
import IncTextField, {
  IncTextFieldProps,
} from 'components/forms/fields/inc-text-field/inc-text-field.component';
import KeyValueField, {
  KeyValueFieldProps,
} from 'components/forms/fields/key-value-field/key-value-field.component';
import NumericStepInputField, {
  NumericStepInputFieldProps,
} from 'components/forms/fields/numeric-step-input-field/numeric-step-input-field.component';
import { BulkEditGridColDef } from 'components/inc-data-grid/bulk-edit-data-grid.types';

const BulkEditDefaultFields = ({ column }: { column: BulkEditGridColDef }) => {
  switch (column.type) {
    case 'string':
      return <StringField name={column.field} label={column.headerName} />;
    case 'number':
      return <NumberField name={column.field} label={column.headerName} />;
    // case 'date':
    //   return 'date';
    // case 'dateTime':
    //   return 'dateTime';
    case 'boolean':
      return <BooleanField name={column.field} label={column.headerName} />;
    case 'singleSelect':
      return (
        <SingleSelectField
          name={column.field}
          label={column.headerName}
          options={(column as GridSingleSelectColDef).valueOptions}
        />
      );
    case 'custom':
      switch (column.customType) {
        case 'keyValue':
          return <KVField name={column.field} />;
      }
  }
};

export default BulkEditDefaultFields;

const StringField = ({ name, label }: Partial<IncTextFieldProps>) => (
  <IncTextField
    name={name}
    label={label}
    data-testid="BulkEditDefaultFields.StringField"
  />
);

const NumberField = ({ name, label }: Partial<NumericStepInputFieldProps>) => (
  <NumericStepInputField
    name={name}
    label={label}
    step={1}
    data-testid="BulkEditDefaultFields.NumberField"
  />
);

const SingleSelectField = ({
  name,
  label,
  options,
}: Partial<AutocompleteFieldProps>) => (
  <AutocompleteField
    name={name}
    label={label}
    options={options}
    data-testid="BulkEditDefaultFields.SingleSelectField"
  />
);

const BooleanField = ({ name, label }: Partial<IncSwitchBaseProps>) => (
  <IncSwitchField
    name={name}
    label={label}
    data-testid="BulkEditDefaultFields.BooleanField"
  />
);

const KVField = ({ name }: Partial<KeyValueFieldProps>) => (
  <Box mt={2}>
    <KeyValueField
      name={name}
      variant="drawer"
      data-testid="BulkEditDefaultFields.KVField"
    />
  </Box>
);
